import { List, Map } from "immutable";
import { createSelector } from "reselect";

import { getAllAssignments } from "seneca-common/features/assignments/features/student-assignments/state";
import * as assignmentSelectors from "seneca-common/features/assignments/features/student-assignments/state/selectors/state/assignments/assignment/studentAssignment";
import { getUserId } from "seneca-common/features/user/state";

export function makeGetNumberOfIncompleteAssignments(
  assignmentIds: List<string>
): (state: any) => number {
  return createSelector(
    getAllAssignments,
    getUserId as any,
    s => assignmentIds,
    getCourseNumberOfIncompleteAssignments
  );
}

export function makeGetNumberOfIncompleteAssignmentsItems(
  assignmentIds: List<string>
): (state: any) => number {
  return createSelector(
    getAllAssignments,
    getUserId as any,
    s => assignmentIds,
    getCourseNumberOfIncompleteAssignmentItems
  );
}

export function makeGetNumberOfIncompleteAssignmentsSections(
  assignmentIds: List<string>
): (state: any) => number {
  return createSelector(
    getAllAssignments,
    getUserId as any,
    s => assignmentIds,
    getCourseNumberOfIncompleteAssignmentSections
  );
}

function filterAssignmentsByIds(
  allAssignments: any,
  assignmentIds: List<string>
) {
  return allAssignments.reduce(
    (acc: any, assignment: any, assignmentId: any) => {
      return acc.withMutations((mutableAssignmentsMap: any) => {
        if (assignmentIds.includes(assignmentId)) {
          return mutableAssignmentsMap.set(assignmentId, assignment);
        }

        return mutableAssignmentsMap;
      });
    },
    Map()
  );
}

function getCourseNumberOfIncompleteAssignmentItems(
  allAssignments: any,
  userId: string,
  assignmentIds: List<string>
): number {
  const assignments = filterAssignmentsByIds(allAssignments, assignmentIds);

  return assignments.reduce((total: number, assignment: any) => {
    const numberOfUnstudiedItems =
      assignmentSelectors.getNumberOfUnstudiedItems(assignment);
    return total + numberOfUnstudiedItems;
  }, 0);
}

function getCourseNumberOfIncompleteAssignmentSections(
  allAssignments: any,
  userId: string,
  assignmentIds: List<string>
): number {
  const assignments = filterAssignmentsByIds(allAssignments, assignmentIds);

  return assignments.reduce((total: number, assignment: any) => {
    const numberOfUnstudiedSections =
      assignmentSelectors.getNumberOfUnstudiedSections(assignment);
    return total + numberOfUnstudiedSections;
  }, 0);
}

function getCourseNumberOfIncompleteAssignments(
  allAssignments: any,
  userId: string,
  assignmentIds: List<string>
): number {
  const assignments = filterAssignmentsByIds(allAssignments, assignmentIds);

  return assignments.reduce((total: number, assignment: any) => {
    const hasUnstudiedItems =
      !!assignmentSelectors.getNumberOfUnstudiedItems(assignment);
    return total + Number(hasUnstudiedItems);
  }, 0);
}
